/* Find my fit - see snippets/fit-finder.liquid for what it does and how it scores. */
(function () {
  var box = document.getElementById('ff');
  if (!box) return;
  var FIT_COLLS = []; try { FIT_COLLS = JSON.parse(box.getAttribute('data-fit-colls') || '[]'); } catch (e) {}
  var CART = box.getAttribute('data-cart') || '/cart', CART_ADD = box.getAttribute('data-cart-add') || '/cart/add';
  var body = box.querySelector('[data-ff-body]');
  var backBtn = box.querySelector('[data-ff-back]');
  var FEED = (box.getAttribute('data-feed') || '/collections/shop-all') + '?view=stylist';
  var SIZE_KEY = 'jdc_size', CACHE_KEY = 'jdc_ff_feed', TTL = 600000;

  var FITS = [
    ['straight', 'Straight'], ['wide-leg', 'Wide leg'], ['relaxed', 'Relaxed'], ['flare', 'Flare & bootcut'],
    ['slim', 'Slim'], ['skinny', 'Skinny'], ['barrel', 'Barrel']
  ];
  var FIT_NAME = {}; FITS.forEach(function (f) { FIT_NAME[f[0]] = f[1]; });
  var SCALE = ['skinny', 'slim', 'straight', 'relaxed', 'wide-leg'];
  var NEAR = { skinny: ['slim'], slim: ['skinny', 'straight'], straight: ['slim', 'relaxed'], relaxed: ['straight', 'wide-leg', 'barrel'],
    'wide-leg': ['relaxed', 'barrel', 'flare'], flare: ['wide-leg'], barrel: ['relaxed', 'wide-leg'] };
  var RISES = ['low', 'mid', 'high'];
  var WASH = [['light', 'Light'], ['mid', 'Mid'], ['dark', 'Dark'], ['black', 'Black'], ['ecru', 'White']];
  var BUDGET = [['0-300', 'Under $300'], ['300-600', '$300–600'], ['600-99999', '$600+']];
  // What the shopper can ask for, and which feed categories each one reads.
  var WHAT = [
    ['jeans', 'Jeans', ['jeans']], ['jackets', 'Jackets', ['jackets']], ['shirts', 'Shirts & tops', ['shirts', 'tops']],
    ['skirts', 'Skirts & dresses', ['skirts-dresses']], ['shorts', 'Shorts', ['shorts']],
    ['outfit', 'An outfit', ['jeans', 'jackets', 'shirts', 'tops'], 'Jeans + a top'],
    ['match', 'Match a pair I love', ['jeans'], 'Find one like yours']
  ];
  var WHAT_CATS = {}, WHAT_NAME = {}; WHAT.forEach(function (w) { WHAT_CATS[w[0]] = w[2]; WHAT_NAME[w[0]] = w[1]; });
  var SECTION_URL = { jeans: 'jeans', jackets: 'jackets', shirts: 'shirts', skirts: 'skirts-dresses', shorts: 'shorts' };

  // Well-known styles, as their makers describe them. s: 1 stretch, 0 rigid, null unknown.
  var PAIRS = [
    ["Levi's 501 Original", 'straight', 'mid', 0, 'mw'], ["Levi's 505 Regular", 'straight', 'mid', null, 'm'],
    ["Levi's 511 Slim", 'slim', 'mid', 1, 'm'], ["Levi's 512 Slim Taper", 'slim', 'mid', 1, 'm'],
    ["Levi's 514 Straight", 'straight', 'mid', null, 'm'], ["Levi's 541 Athletic Taper", 'slim', 'mid', 1, 'm'],
    ["Levi's 550 Relaxed", 'relaxed', 'mid', null, 'm'], ["Levi's Ribcage Straight Ankle", 'straight', 'high', 0, 'w'],
    ["Levi's Wedgie Straight", 'straight', 'high', 0, 'w'], ["Levi's 70s High Flare", 'flare', 'high', 1, 'w'],
    ["Levi's Baggy Dad", 'relaxed', 'high', 0, 'w'], ["AGOLDE '90s Pinch Waist", 'straight', 'high', 0, 'w'],
    ['AGOLDE Riley', 'straight', 'high', 0, 'w'], ['AGOLDE Low Slung Baggy', 'wide-leg', 'low', 0, 'w'],
    ['AGOLDE Criss Cross', 'straight', 'high', 0, 'w'], ['MOTHER The Insider', 'flare', 'high', 1, 'w'],
    ['Madewell The Perfect Vintage Jean', 'straight', 'high', 0, 'w'], ['RE/DONE 90s High Rise Loose', 'relaxed', 'high', 0, 'w'],
    ['A.P.C. Petit New Standard', 'slim', 'mid', 0, 'm'], ['A.P.C. Petit Standard', 'slim', 'mid', 0, 'm'],
    ['Nudie Lean Dean', 'slim', 'mid', 1, 'm']
  ];

  var S, feed = null, loading = null, hist = [], lastFocus = null, shown = {};

  function fresh(gs) { return { gs: gs || [], whats: [], pairs: [], shapes: [], sizes: [], fits: [], changes: [],
    chips: { budget: [], wash: [], rise: [], po: false } }; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function head(v) { return String(v).split('/')[0].replace(/^w\s*/i, '').trim().toUpperCase(); }
  function money(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
  function has(a, x) { return a.indexOf(x) > -1; }
  function toggle(a, x) { var i = a.indexOf(x); if (i > -1) a.splice(i, 1); else a.push(x); }
  function track(name, data) { try { window.Shopify && Shopify.analytics && Shopify.analytics.publish(name, data || {}); } catch (e) {} }
  function wants(k) { return has(S.whats, k); }

  // ---- feed -------------------------------------------------------------
  function load() {
    if (feed) return Promise.resolve(feed);
    if (loading) return loading;
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.at < TTL) { feed = c.items; return Promise.resolve(feed); }
    } catch (e) {}
    function page(n) { return fetch(FEED + '&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(JSON.parse); }
    loading = page(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(page(n));
      return Promise.all(rest).then(function (more) {
        var items = first.items;
        more.forEach(function (m) { items = items.concat(m.items); });
        feed = items;
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), items: items })); } catch (e) {}
        return feed;
      });
    });
    loading.catch(function () { loading = null; });
    return loading;
  }

  // ---- open / close -----------------------------------------------------
  function open(g) {
    lastFocus = document.activeElement;
    S = fresh(g ? [g] : []); hist = []; shown = {};
    box.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    load().catch(function () {});
    go(g ? 'what' : 'who', true);
    track('stylist_open', { g: g || '' });
  }
  function close() {
    box.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fit-open]');
    if (t) { e.preventDefault(); open(t.getAttribute('data-fit-g')); return; }
    if (e.target.closest('[data-ff-close]') || e.target === box) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
  backBtn.addEventListener('click', function () { var prev = hist.pop(); if (prev) go(prev, true); });

  var step = null;
  function go(name, noPush) {
    if (!noPush && step) hist.push(step);
    step = name;
    backBtn.hidden = hist.length === 0;
    STEPS[name]();
    var f = body.querySelector('input, button');
    if (f) f.focus({ preventScroll: true });
    body.parentNode.scrollTop = 0;
  }

  // The order the questions come in, given what has been picked so far.
  function nextAfter(name) {
    var order = ['who', 'what'];
    if (wants('match')) order.push('pair');
    if (wants('match') && S.pairs.indexOf('__other') > -1) order.push('shape');
    order.push('size');
    if (wants('jeans') || wants('outfit')) order.push('fit');
    if (wants('match')) order.push('change');
    order.push('results');
    var i = order.indexOf(name);
    return order[i + 1] || 'results';
  }

  // A multi-select question: tap any number of options, then Next.
  // `list` rows are [value, label, svg, hint]; `arr` is the state array.
  function multi(title, list, arr, opts) {
    opts = opts || {};
    body.innerHTML = '<h2>' + title + '</h2><p class="ff__hint">Pick as many as you like.</p>' +
      '<div class="ff__opts' + (opts.cls ? ' ' + opts.cls : '') + '">' + list.map(function (o) {
        return '<button type="button" class="ff__opt" aria-pressed="' + has(arr, o[0]) + '" data-v="' + esc(o[0]) + '">' + (o[2] || '') +
          '<span>' + esc(o[1]) + '</span>' + (o[3] ? '<small>' + esc(o[3]) + '</small>' : '') + '</button>';
      }).join('') + '</div>' + (opts.after || '') +
      '<div class="ff__nextbar"><button type="button" class="ff__all" data-ff-all>' + (opts.allLabel || 'Select all') + '</button>' +
      '<button type="button" class="ff__next" data-ff-next>Next</button></div>';
    var next = body.querySelector('[data-ff-next]');
    function sync() {
      next.disabled = opts.required && !arr.length;
      next.textContent = arr.length || !opts.skipLabel ? 'Next' : opts.skipLabel;
    }
    body.querySelectorAll('.ff__opt[data-v]').forEach(function (b) {
      b.addEventListener('click', function () {
        toggle(arr, b.getAttribute('data-v'));
        b.setAttribute('aria-pressed', has(arr, b.getAttribute('data-v')));
        sync();
      });
    });
    body.querySelector('[data-ff-all]').addEventListener('click', function () {
      var vals = list.map(function (o) { return o[0]; });
      var allOn = vals.every(function (v) { return has(arr, v); });
      arr.length = 0;
      if (!allOn) vals.forEach(function (v) { arr.push(v); });
      body.querySelectorAll('.ff__opt[data-v]').forEach(function (b) { b.setAttribute('aria-pressed', has(arr, b.getAttribute('data-v'))); });
      sync();
    });
    next.addEventListener('click', function () { if (opts.onNext) opts.onNext(); go(nextAfter(step)); });
    sync();
  }

  // Simple leg silhouettes, one per fit.
  function legs(fit) {
    var P = { skinny: [-4, -6, 8, 9], slim: [-3, -4, 10, 10], straight: [-2, -2, 12, 11], relaxed: [0, 0, 14, 13],
      'wide-leg': [2, 6, 20, 15], flare: [-4, 6, 18, 9], barrel: [5, -1, 13, 15] }[fit];
    if (!P) return '';
    var kx = P[0], hx = P[1], hw = P[2], kw = P[3];
    var pts = [[14, 4], [46, 4], [46 + kx, 46], [46 + hx, 76], [46 + hx - hw, 76], [46 + kx - kw, 46], [30, 30],
      [14 - kx + kw, 46], [14 - hx + hw, 76], [14 - hx, 76], [14 - kx, 46]];
    return '<svg viewBox="0 0 60 80" aria-hidden="true"><path d="M' + pts.map(function (p) { return p.join(' '); }).join(' L') + ' Z"/></svg>';
  }

  // ---- steps ------------------------------------------------------------
  var STEPS = {
    who: function () {
      multi('Who’s it for?', [['w', 'Women'], ['m', 'Men']], S.gs, { required: true });
    },
    what: function () {
      multi('What are you after?', WHAT.map(function (w) { return [w[0], w[1], '', w[3]]; }), S.whats, { required: true });
    },
    pair: function () {
      var list = PAIRS.filter(function (p) { return S.gs.some(function (g) { return p[4].indexOf(g) > -1; }); });
      body.innerHTML = '<h2>Which pairs do you love?</h2><p class="ff__hint">Pick as many as you like.</p>' +
        '<input class="ff__in" type="search" placeholder="Brand and style, e.g. Levi’s 501" autocomplete="off" data-ff-q aria-label="Brand and style">' +
        '<div class="ff__chips" data-ff-list></div>' +
        '<div class="ff__nextbar"><button type="button" class="ff__all" data-ff-other>' + (has(S.pairs, '__other') ? '✓ ' : '') + 'Mine isn’t listed</button>' +
        '<button type="button" class="ff__next" data-ff-next>Next</button></div>';
      var q = body.querySelector('[data-ff-q]'), out = body.querySelector('[data-ff-list]'), next = body.querySelector('[data-ff-next]');
      function sync() { next.disabled = !S.pairs.length; }
      function draw() {
        var n = norm(q.value);
        var hits = list.filter(function (p) { return !n || norm(p[0]).indexOf(n) > -1 || has(S.pairs, p[0]); });
        out.innerHTML = hits.map(function (p) { return '<button type="button" class="ff__chip" aria-pressed="' + has(S.pairs, p[0]) + '" data-v="' + esc(p[0]) + '">' + esc(p[0]) + '</button>'; }).join('') ||
          '<p class="ff__note">Not on our list yet. Tap “Mine isn’t listed” and pick its shape.</p>';
        out.querySelectorAll('[data-v]').forEach(function (b) {
          b.addEventListener('click', function () { toggle(S.pairs, b.getAttribute('data-v')); b.setAttribute('aria-pressed', has(S.pairs, b.getAttribute('data-v'))); sync(); });
        });
      }
      q.addEventListener('input', draw); draw(); sync();
      body.querySelector('[data-ff-other]').addEventListener('click', function (e) {
        toggle(S.pairs, '__other');
        e.currentTarget.textContent = (has(S.pairs, '__other') ? '✓ ' : '') + 'Mine isn’t listed';
        if (has(S.pairs, '__other')) track('stylist_match_unknown', { q: q.value });
        sync();
      });
      next.addEventListener('click', function () {
        S.pairs.forEach(function (n) { if (n !== '__other') track('stylist_match', { style: n }); });
        go(nextAfter('pair'));
      });
    },
    shape: function () {
      multi('What shape is the leg on yours?', FITS.map(function (f) { return [f[0], f[1], legs(f[0])]; }), S.shapes, { cls: 'ff__opts--fit', required: true });
    },
    size: function () {
      body.innerHTML = '<p class="ff__load">One moment…</p>';
      load().then(function () {
        var count = {};
        allCats().forEach(function (cat) {
          pool(cat).forEach(function (p) {
            var seen = {};
            p.z.forEach(function (z) { var h = head(z[1]); if (!seen[h]) { seen[h] = 1; count[h] = (count[h] || 0) + 1; } });
          });
        });
        var heads = Object.keys(count).sort(sizeSort);
        if (!S.sizes.length && !S.sizesTouched) savedHeads().forEach(function (h) { if (heads.indexOf(h) > -1 && !has(S.sizes, h)) S.sizes.push(h); });
        multi(wants('match') && S.whats.length === 1 ? 'Your sizes in those pairs?' : 'Your sizes?', heads.map(function (h) { return [h, h]; }), S.sizes, {
          cls: 'ff__opts--size', allLabel: 'Every size', skipLabel: 'Skip, show every size',
          after: '<p class="ff__note">We also show the same size in other systems, so 27 includes S and IT 40.' + (wants('match') ? ' Brands vary a little, so check each size chart.' : '') + '</p>',
          onNext: function () { S.sizesTouched = true; if (S.sizes.length) saveSizes(); }
        });
      }, failed);
    },
    fit: function () {
      multi('Which fits?', FITS.map(function (f) { return [f[0], f[1], legs(f[0])]; }), S.fits, { cls: 'ff__opts--fit', allLabel: 'Every fit', skipLabel: 'Skip, show every fit' });
    },
    change: function () {
      multi('Anything to change?', [
        ['wider', 'A bit wider'], ['slimmer', 'A bit slimmer'], ['higher', 'Higher rise'], ['lower', 'Lower rise'],
        ['stretch', 'More stretch'], ['rigid', 'Less stretch']
      ], S.changes, { skipLabel: 'Keep it the same', allLabel: 'Show me everything' });
    },
    results: function () {
      body.innerHTML = '<p class="ff__load">Finding your picks…</p>';
      load().then(function () { shown = {}; drawResults(); track('stylist_results', { what: S.whats.join(','), g: S.gs.join(',') }); }, failed);
    }
  };

  function failed() {
    body.innerHTML = '<p>That didn’t load. Check your connection and try again.</p><div class="ff__more"><button type="button" data-ff-retry>Try again</button></div>';
    body.querySelector('[data-ff-retry]').addEventListener('click', function () { go(step, true); });
  }

  // ---- sizes ------------------------------------------------------------
  function sizeSort(a, b) {
    var L = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
    var na = parseFloat(a), nb = parseFloat(b);
    if (!isNaN(na) && !isNaN(nb)) return na - nb;
    if (!isNaN(na)) return 1; if (!isNaN(nb)) return -1;
    var ia = L.indexOf(a), ib = L.indexOf(b);
    if (ia > -1 && ib > -1) return ia - ib;
    if (ia > -1) return -1; if (ib > -1) return 1;
    return a < b ? -1 : 1;
  }
  function savedHeads() {
    try { return (JSON.parse(localStorage.getItem(SIZE_KEY) || '[]')).map(head); } catch (e) { return []; }
  }
  function saveSizes() {
    var vals = {};
    allCats().forEach(function (cat) { pool(cat).forEach(function (p) { p.z.forEach(function (z) { if (has(S.sizes, head(z[1]))) vals[z[1]] = 1; }); }); });
    try { localStorage.setItem(SIZE_KEY, JSON.stringify(Object.keys(vals))); } catch (e) {}
  }
  // The chosen sizes plus the same size in other systems (27 = S = IT 40),
  // read from window.jdcSizeEquiv (snippets/jdc-sizes) for the product's gender.
  var eqCache = {};
  function wanted(g) {
    var k = g + '|' + S.sizes.join(',');
    if (eqCache[k]) return eqCache[k];
    var out = S.sizes.slice();
    if (window.jdcSizeEquiv) {
      (g.length ? g.split('') : ['w', 'm']).forEach(function (gg) {
        S.sizes.forEach(function (h) { window.jdcSizeEquiv(gg, h).forEach(function (x) { if (out.indexOf(x) < 0) out.push(x); }); });
      });
    }
    return (eqCache[k] = out);
  }
  function sizeVariants(p) {
    if (!S.sizes.length) return [];
    var w = wanted(p.g || '');
    return p.z.filter(function (z) { return has(w, head(z[1])); });
  }

  // ---- scoring ----------------------------------------------------------
  function allCats() {
    var c = [];
    S.whats.forEach(function (w) { (WHAT_CATS[w] || []).forEach(function (x) { if (!has(c, x)) c.push(x); }); });
    return c;
  }
  function pool(cat) {
    var cats = typeof cat === 'string' ? [cat] : cat;
    return (feed || []).filter(function (p) { return has(cats, p.c) && S.gs.some(function (g) { return p.g.indexOf(g) > -1; }); });
  }
  function shift(scale, v, d) { var i = scale.indexOf(v); if (i < 0) return v; return scale[Math.max(0, Math.min(scale.length - 1, i + d))]; }
  function addU(a, v) { if (v != null && !has(a, v)) a.push(v); }

  // Wanted fits / rises / stretch for one section. Every pick and every change counts.
  function want(section) {
    var w = { fits: [], rises: [], s: [] };
    if (section === 'match') {
      var bases = [];
      S.pairs.forEach(function (n) {
        if (n === '__other') { S.shapes.forEach(function (f) { bases.push({ f: f, r: null, s: null }); }); return; }
        var p = PAIRS.filter(function (x) { return x[0] === n; })[0];
        if (p) bases.push({ f: p[1], r: p[2], s: p[3] });
      });
      bases.forEach(function (b) {
        if (!S.changes.length || (has(S.changes, 'wider') && has(S.changes, 'slimmer'))) addU(w.fits, b.f);
        if (has(S.changes, 'wider')) addU(w.fits, b.f === 'flare' || b.f === 'barrel' ? 'wide-leg' : shift(SCALE, b.f, 1));
        if (has(S.changes, 'slimmer')) addU(w.fits, b.f === 'flare' ? 'straight' : b.f === 'barrel' ? 'relaxed' : shift(SCALE, b.f, -1));
        if (!has(S.changes, 'wider') && !has(S.changes, 'slimmer')) addU(w.fits, b.f);
        var r = b.r;
        if (has(S.changes, 'higher')) addU(w.rises, shift(RISES, r || 'mid', 1));
        if (has(S.changes, 'lower')) addU(w.rises, shift(RISES, r || 'mid', -1));
        if (!has(S.changes, 'higher') && !has(S.changes, 'lower')) addU(w.rises, r);
        if (has(S.changes, 'stretch')) addU(w.s, 1);
        if (has(S.changes, 'rigid')) addU(w.s, 0);
        if (!has(S.changes, 'stretch') && !has(S.changes, 'rigid')) addU(w.s, b.s);
      });
    } else if (section === 'jeans' || section === 'outfit') {
      w.fits = S.fits.slice();
    }
    if (S.chips.rise.length) w.rises = S.chips.rise.slice();
    return w;
  }

  function rank(cats, w, opt) {
    opt = opt || {};
    var c = S.chips, list = [];
    pool(cats).forEach(function (p) {
      if (p.po && !c.po) return;
      var vs = opt.anySize ? [] : sizeVariants(p);
      if (S.sizes.length && !opt.anySize && !vs.length) return;
      var price = vs.length ? Math.min.apply(null, vs.map(function (z) { return z[2]; })) : p.p;
      // Tops in an outfit ignore the chips: they are about the jeans.
      if (!opt.top && c.budget.length && !c.budget.some(function (b) { b = b.split('-'); return price >= +b[0] && price < +b[1]; })) return;
      if (!opt.top && c.wash.length && !has(c.wash, p.w)) return;
      if (!opt.top && c.rise.length && p.r && !has(c.rise, p.r)) return;
      var sc = 0;
      if (w.fits.length) sc += has(w.fits, p.f) ? 6 : w.fits.some(function (f) { return has(NEAR[f] || [], p.f); }) ? 2 : p.f ? -4 : 1;
      if (w.rises.length) sc += has(w.rises, p.r) ? 3 : p.r ? -1 : 0.5;
      if (w.s.length) sc += has(w.s, p.s) ? 1.5 : p.s == null ? 0 : -1;
      if (p.bp) sc += 0.7;
      list.push({ p: p, vs: vs, price: price, sc: sc });
    });
    // With enough exact fits, leave out pieces known to be a different shape.
    if (w.fits.length) {
      var exact = list.filter(function (x) { return has(w.fits, x.p.f); }).length;
      if (exact >= 3) list = list.filter(function (x) { return !x.p.f || has(w.fits, x.p.f) || w.fits.some(function (f) { return has(NEAR[f] || [], x.p.f); }); });
    }
    list.sort(function (a, b) { return b.sc - a.sc || a.price - b.price; });
    // The first picks never repeat a brand.
    var out = [], used = {}, rest = [];
    list.forEach(function (x) { if (out.length < 6 && !used[x.p.b]) { used[x.p.b] = 1; out.push(x); } else rest.push(x); });
    return out.concat(rest);
  }

  function why(x, w, section) {
    var p = x.p, bits = [];
    if (x.vs.length) bits.push('In your size ' + x.vs.map(function (z) { return head(z[1]); }).filter(function (h, i, a) { return a.indexOf(h) === i; }).join(', '));
    if (section === 'match' && p.f && has(w.fits, p.f)) bits.push(FIT_NAME[p.f] + ' leg');
    else if (p.f && FIT_NAME[p.f]) bits.push(FIT_NAME[p.f]);
    if (p.r) bits.push(p.r.charAt(0).toUpperCase() + p.r.slice(1) + ' rise');
    if (p.c === 'jeans') { if (p.s === 1) bits.push('stretch'); else if (p.s === 0) bits.push('rigid'); }
    if (p.bp) bits.push('Best price');
    return bits.join(' · ');
  }

  function card(x, w, section) {
    var p = x.p, adds;
    var seen = {}, vs = x.vs.filter(function (z) { var h = head(z[1]); if (seen[h]) return false; seen[h] = 1; return true; }).slice(0, 4);
    if (vs.length) adds = '<div class="ff__adds">' + vs.map(function (z) {
      return '<button type="button" class="ff__add" data-add="' + z[0] + '" data-size="' + esc(head(z[1])) + '">Add · ' + esc(head(z[1])) + '</button>';
    }).join('') + '</div>';
    else adds = '<a class="ff__add" style="display:flex;align-items:center;justify-content:center" href="' + esc(p.u) + '">Choose size</a>';
    return '<div class="ff__card"><a href="' + esc(p.u) + '" data-ff-view="' + p.i + '">' +
      (p.im ? '<img src="' + esc(p.im) + '" alt="" loading="lazy">' : '') +
      '<b>' + esc(p.b) + '</b>' + esc(p.t) + '<br>' + money(x.price) + '</a>' +
      '<p class="ff__why">' + esc(why(x, w, section)) + '</p>' + adds + '</div>';
  }

  function chipRow() {
    var c = S.chips, h = '';
    function chip(k, v, label, on) { return '<button type="button" class="ff__chip" data-chip="' + k + '" data-cv="' + v + '" aria-pressed="' + on + '">' + label + '</button>'; }
    BUDGET.forEach(function (b) { h += chip('budget', b[0], b[1], has(c.budget, b[0])); });
    WASH.forEach(function (x) { h += chip('wash', x[0], x[1], has(c.wash, x[0])); });
    if (wants('jeans') || wants('outfit') || wants('match') || wants('shorts')) RISES.slice().reverse().forEach(function (r) { h += chip('rise', r, r.charAt(0).toUpperCase() + r.slice(1) + ' rise', has(c.rise, r)); });
    h += chip('po', '1', 'Include pre-owned', !!c.po);
    return '<p class="ff__hint" style="margin:0 0 8px">Narrow down: tap as many as you like.</p><div class="ff__refine" role="group" aria-label="Refine">' + h + '</div>';
  }

  function seeAllUrl(section, w) {
    var gpath = S.gs.length === 1 ? (S.gs[0] === 'w' ? 'women' : 'men') : null;
    var key = section === 'outfit' || section === 'match' ? 'jeans' : section;
    var base = '/collections/shop-' + (gpath ? gpath + '-' : '') + SECTION_URL[key];
    if (key === 'jeans' && w.fits.length === 1 && gpath && FIT_COLLS.indexOf('fit-' + w.fits[0] + '-' + gpath) > -1) base = '/collections/fit-' + w.fits[0] + '-' + gpath;
    if (!S.sizes.length) return base;
    var vals = {};
    pool(WHAT_CATS[key] || [key]).forEach(function (p) { p.z.forEach(function (z) { if (has(S.sizes, head(z[1]))) vals[z[1]] = 1; }); });
    return base + '?' + Object.keys(vals).map(function (v) { return 'filter.v.option.size=' + encodeURIComponent(v); }).join('&');
  }

  function sections() {
    // One block of results per thing asked for, in the order of the question.
    return WHAT.map(function (x) { return x[0]; }).filter(function (k) { return wants(k); });
  }

  function drawResults() {
    var html = chipRow() + '<div class="ff__meta"><span>' + (S.sizes.length ? 'Sizes: ' + esc(S.sizes.join(', ')) : 'Every size') + '</span><button type="button" data-ff-restart>Start again</button></div>';
    sections().forEach(function (sec) {
      var w = want(sec);
      var list = rank(WHAT_CATS[sec], w);
      var n = shown[sec] || 3;
      var title = sec === 'match' ? 'Like the pairs you love' : sec === 'outfit' ? 'Outfits' : WHAT_NAME[sec];
      html += '<section class="ff__sec"><h2>' + esc(title) + ' <span class="ff__count">' + list.length + '</span></h2>';
      if (!list.length) html += noneHelp(sec, w);
      else if (sec === 'outfit') html += outfits(list.slice(0, n), w);
      else html += '<div class="ff__picks">' + list.slice(0, n).map(function (x) { return card(x, w, sec); }).join('') + '</div>';
      if (list.length) html += '<div class="ff__more">' + (list.length > n ? '<button type="button" data-ff-more="' + sec + '">Show more</button>' : '') +
        '<a href="' + esc(seeAllUrl(sec, w)) + '">See all on the site</a></div>';
      html += '</section>';
    });
    body.innerHTML = html;
    wireResults();
  }

  function noneHelp(sec, w) {
    var h = '<div class="ff__none"><p>Nothing in stock matches all of that right now.</p><div class="ff__chips">';
    if (S.sizes.length) {
      var keep = S.sizes; S.sizes = [];
      var any = rank(WHAT_CATS[sec], w).length; S.sizes = keep;
      if (any) h += '<button type="button" class="ff__chip" data-fix="size">Every size (' + any + ')</button>';
    }
    var c = S.chips;
    if (c.budget.length || c.wash.length || c.rise.length) h += '<button type="button" class="ff__chip" data-fix="chips">Clear the filters</button>';
    if (w.fits.length && sec === 'jeans') h += '<button type="button" class="ff__chip" data-fix="fits">Every fit</button>';
    return h + '</div></div>';
  }

  // An outfit: the jeans pick plus a jacket or shirt in a wash at least two
  // steps away, so the two pieces read as separate.
  function outfits(jeans, w) {
    var order = ['ecru', 'light', 'mid', 'dark', 'raw', 'black'];
    var usedTop = {};
    var tops = rank(['jackets', 'shirts', 'tops'], { fits: [], rises: [], s: [] }, { anySize: true, top: true });
    return jeans.map(function (x) {
      var jw = order.indexOf(x.p.w);
      var top = tops.filter(function (t) { return !usedTop[t.p.i] && t.p.b !== x.p.b && (jw < 0 || order.indexOf(t.p.w) < 0 || Math.abs(order.indexOf(t.p.w) - jw) >= 2); })[0];
      if (top) usedTop[top.p.i] = 1;
      var total = x.price + (top ? top.p.p : 0);
      return '<div class="ff__out"><div class="ff__out-h"><span>Outfit</span><span>' + money(total) + '</span></div>' + card(x, w, 'outfit') +
        (top ? card({ p: top.p, vs: [], price: top.p.p }, w, 'outfit') : '<div class="ff__card"><p class="ff__why">Wear it with a white tee you already own.</p></div>') + '</div>';
    }).join('');
  }

  function wireResults() {
    body.querySelectorAll('[data-chip]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-chip'), v = b.getAttribute('data-cv');
        if (k === 'po') S.chips.po = !S.chips.po; else toggle(S.chips[k], v);
        shown = {}; drawResults();
        var again = body.querySelector('[data-chip="' + k + '"][data-cv="' + v + '"]'); if (again) again.focus({ preventScroll: true });
      });
    });
    body.querySelectorAll('[data-ff-more]').forEach(function (b) {
      b.addEventListener('click', function () { var s = b.getAttribute('data-ff-more'); shown[s] = (shown[s] || 3) + 6; drawResults(); });
    });
    body.querySelector('[data-ff-restart]').addEventListener('click', function () { S = fresh(S.gs); hist = []; go('what', true); });
    body.querySelectorAll('[data-fix]').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-fix');
        if (f === 'size') S.sizes = [];
        else if (f === 'chips') S.chips = { budget: [], wash: [], rise: [], po: S.chips.po };
        else if (f === 'fits') S.fits = [];
        drawResults();
      });
    });
    body.querySelectorAll('[data-ff-view]').forEach(function (a) { a.addEventListener('click', function () { track('stylist_pick_view', { id: a.getAttribute('data-ff-view') }); }); });
    body.querySelectorAll('[data-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('is-done')) { location.href = CART; return; }
        b.disabled = true; b.textContent = 'Adding…';
        fetch(CART_ADD + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +b.getAttribute('data-add'), quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw r; return fetch(CART + '.js').then(function (c) { return c.json(); }); })
          .then(function (cart) {
            b.disabled = false; b.classList.add('is-done'); b.textContent = 'Added ' + b.getAttribute('data-size') + ' · View bag';
            document.querySelectorAll('a[href="' + CART + '"]').forEach(function (a) { if (/^Bag/.test(a.textContent.trim())) a.textContent = 'Bag (' + cart.item_count + ')'; });
            track('stylist_add', { variant: b.getAttribute('data-add') });
          })
          .catch(function () { b.disabled = false; b.textContent = 'Sold out, sorry'; });
      });
    });
  }
})();
